import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { AppUtilityService } from './app-utility.service';
import { merge } from 'lodash';
import { toJS } from 'mobx';
import { observable } from 'mobx-angular';
import { BasicModalComponent } from '../../module/fna/components/basic-modal/basic-modal.component';
import { RiskLevel } from '../models/fna';
import { SideBarService } from './side-bar.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalsService {
  @observable model: { [key: string]: any } = {};
  @observable showLastTimeSavedMobile: boolean = true;
  @observable isMobile = false;
  @observable isLessThan1200Width = false;
  @observable isLoading = false;

   // Feature flags
   @observable isEnableSaveDraftFeature = true;

  // ==================
  // For mock and debug
  // ==================
  // appClass = '';
  @observable isDebug = false;
  @observable mockedDeclaredRisk: RiskLevel | null = null;
  @observable mockedAssessedRisk: RiskLevel | null = null;
  @observable simulateServerBehaviour: boolean = true;
  @observable mockHasReadTermsAndConditions: boolean = false;
  @observable mockHasReadPurposeOfFormModal: boolean = false;
  @observable mockIsAcceptAssessedRiskProfile: boolean | null = null;
  @observable mockIsAcceptRecommendedProducts: boolean | null = null;
  @observable mockIsPurchaseTableBProducts: boolean | null = null;
  @observable mockedIsAccountLocked :boolean =  false;
  @observable mockedIsFirstTimeLogin :boolean =  false;


  constructor(
    private modalService: NgbModal,
    protected sideBarService: SideBarService,
    private router: Router,
  ) {}

  updateModel(newModel: any) {
    this.model = merge({}, this.model, newModel);
  }

  async routeToLogin(){
    await this.router.navigateByUrl('/login');
  }

  logModelForDebug() {
    console.log(toJS(this.model));
  }

  /**
   * Show error modal
   */
  showErrorModal(
    body: string,
    title: string = 'Error',
    buttonText: string = 'Okay',
  ) {
    const modalRef = this.modalService.open(BasicModalComponent, {
      size: 'lg',
      centered: true,
      modalDialogClass: 'fna-modal-dialog',
      backdropClass: 'fna-modal-backdrop',
    });

    modalRef.componentInstance.title = title;
    modalRef.componentInstance.content = body;
    modalRef.componentInstance.buttonText = buttonText;
  }

  /**
   * Show global laoder.
   */
  showLoader() {
    this.isLoading = true;
  }

  /**
   * Hide global loader.
   */
  hideLoader() {
    this.isLoading = false;
  }

  /**
   * Show last saved time for 5 seconds
   */
  showLastSaveTime() {
    // In milliseconds
    const lastSavedTimeExpiryPeriod = 5000;

    setTimeout(() => {
      this.showLastTimeSavedMobile = false;
    }, lastSavedTimeExpiryPeriod);
  }

  async updateSideBarStepper(data: any, screenName: string) {
    console.log('updateSideBarStepper: ', data);

    const checkScreenNames = [
      'RiskProfileAssessment',
      'RecommendedProducts',
      'NonRecommendedProducts',
    ];

    const isCheckingScreenName = checkScreenNames.includes(screenName);

    if (!isCheckingScreenName) {
      return;
    }

    if (
      screenName === 'RecommendedProducts' &&
      (data.IsAcceptAssessedRiskProfile === null ||
        data.IsAcceptAssessedRiskProfile === false)
    ) {
      await this.router.navigateByUrl('/fna/risk-profile-assessment');
      return;
    }

    if (data.IsAcceptAssessedRiskProfile === false) {
      this.sideBarService.showNonRecommendedProduct = true;
      this.sideBarService.showRecommendedProduct = false;
    } else {
      this.sideBarService.showRecommendedProduct = true;

      if (data.IsAcceptRecommendedProducts === false) {
        this.sideBarService.showNonRecommendedProduct = true;
      } else if (data.IsPurchaseTableBProducts === true) {
        this.sideBarService.showNonRecommendedProduct = true;
      } else {
        this.sideBarService.showNonRecommendedProduct = false;
        if (screenName === 'NonRecommendedProducts') {
          await this.router.navigateByUrl('/fna/risk-profile-assessment');
        }
      }
    }
  }
}
